import React from 'react';
import PropTypes from 'prop-types';

import {connect} from 'react-redux';

import $ from 'jquery';

import classNames from 'classnames';

import I18n from '@js/modules/translations';
import * as Utils from '@js/modules/utils';

// import Swal from 'sweetalert2';

import {
    fetchBlogArticle,
    toggleEditMode,
    // deleteBlogArticle
} from '@js/actions';

import {
    getIsOwner,
} from '@js/selectors';

import BlogArticle from './display/article';
import BlogForm from './display/form';

import CommentBox from '../loaders/commentBox';


class BlogArticleShow extends React.PureComponent {
    static propTypes = {
        articleId: PropTypes.number,
        isCommented: PropTypes.bool,
        // From connect
        currentUserId: PropTypes.number,
        currentAdminId: PropTypes.number,
        isOwner: PropTypes.bool,
        article: PropTypes.object,
        isEditing: PropTypes.bool,
        fetchBlogArticle: PropTypes.func,
        toggleEditMode: PropTypes.func,
        // deleteBlogArticle: PropTypes.func
    };

    static defaultProps = {
        article: {},
        isOwner: false,
        isCommented: true
    };

    constructor(props) {
        super(props);

        this._blogForm = React.createRef();
    }

    componentDidMount() {
        if (Utils.isEmpty(this.props.article) && this.props.articleId) {
            this.props.fetchBlogArticle(this.props.currentUserId, this.props.articleId);
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.article !== this.props.article) {
            window.onbeforeunload = null;
        }
    }

    _handleCancelForm = () => {
        this.props.toggleEditMode();
    };

    _handleClickEdit = (event) => {
        event.preventDefault();

        if (!this.props.isEditing) {
            if (this._blogForm.current) {
                $('html, body')
                    .animate({scrollTop: this._blogForm.current.getBoundingClientRect().top - 64}, 750);
            }

            window.onbeforeunload = () => {
                return true;
            };

            this.props.toggleEditMode();
        }
    };

    // _handleDeleteEdit = (event) => {
    //     event.preventDefault();
    //
    //     // Swal
    //     //     .fire({
    //     //         type: 'warning',
    //     //         title: I18n.t('js.helpers.confirm'),
    //     //         text: I18n.t('js.blog.article.delete.confirmation'),
    //     //     })
    //     //     .then((result) => {
    // if (result.isConfirmed) {
    //     //         this.props.deleteBlogArticle(this.props.currentUserId, this.props.article.id);
    // }
    //     //     });
    // };

    render() {
        if (!this.props.article) {
            return null;
        }

        return (
            <div className="blog">
                <div className="row">
                    <div ref={this._blogForm}
                         className="col s12 margin-bottom-30">
                        {
                            !!(this.props.isOwner && this.props.isEditing) &&
                            <BlogForm currentUserId={this.props.currentUserId}
                                      currentAdminId={this.props.currentAdminId}
                                      isEditing={true}
                                      isTitled={!this.props.currentAdminId}
                                      isTagged={!this.props.currentAdminId}
                                      onCancel={this._handleCancelForm}>
                                {this.props.article}
                            </BlogForm>
                        }

                        {
                            !!(this.props.isOwner && !this.props.isEditing) &&
                            <div className="blog-article-edit-icon">
                                <a className="btn waves-effect waves-light"
                                   href="#"
                                   onClick={this._handleClickEdit}>
                                    <span className="material-icons"
                                          data-icon="edit"
                                          aria-hidden="true"/>
                                </a>
                            </div>
                        }

                        <BlogArticle article={this.props.article}
                                     isAdmin={!!this.props.currentAdminId}/>
                    </div>

                    {
                        !!(this.props.isOwner && !this.props.currentAdminId) &&
                        <div className="col s12 m6 center-align">
                            <a className="btn-flat waves-effect waves-light"
                               href="#"
                               data-confirm={I18n.t('js.blog.article.delete.confirmation')}
                                // onClick={this._handleDeleteEdit}
                            >
                                {I18n.t('js.blog.article.delete.button')}
                            </a>
                        </div>
                    }

                    {
                        !!this.props.isOwner &&
                        <div className={classNames('col s12 center-align', {m6: !this.props.currentAdminId})}>
                            <a className="btn-flat waves-effect waves-light"
                               href="#"
                               onClick={this._handleClickEdit}>
                                {I18n.t('js.blog.article.edit.button')}
                            </a>
                        </div>
                    }

                    {
                        !!this.props.isCommented &&
                        <div className="col s12">
                            <CommentBox id={`article-comments-${this.props.article.id}`}
                                        commentableId={this.props.article.id}
                                        ownerId={this.props.article.user.id}
                                        isOwner={this.props.isOwner}
                                        commentsCount={this.props.article.commentsCount}
                                        isUserOwner={this.props.isOwner}
                                        isPaginated={false}
                                        isRated={true}/>
                        </div>
                    }
                </div>
            </div>
        );
    }
}


export default connect((state, props) => {
    const article = state.blogArticleState.blogArticle || props.article;
    const adminId = state.adminState && state.adminState.currentId;

    return ({
        isOwner: !!adminId || getIsOwner(state, article && article.user && article.user.id),
        currentUserId: state.userState.currentId,
        currentAdminId: adminId,
        article: article,
        isEditing: state.blogArticleState.isEditing
    });
}, {
    fetchBlogArticle,
    toggleEditMode,
    // deleteBlogArticle
})(BlogArticleShow);
